/**
 * WarningsPanel — renders the list of blockers / warnings / infos from the
 * agent's validate_plan output, each as a small card with [Resolve] button.
 *
 * Resolve dispatches a user.message asking the agent to address the issue;
 * the agent may apply an edit via apply_plan_edit or explain why it can't.
 */

import React from 'react';

const SEV_STYLE = {
  blocker: { bg: '#fdecea', border: '#e5534b', color: '#a40000', icon: '✕' },
  warning: { bg: '#fff4e0', border: '#d4a72c', color: '#8a4a00', icon: '!' },
  info:    { bg: '#ddf4ff', border: '#54aeff', color: '#0969da', icon: 'i' },
};

const WarningsPanel = ({ warnings }) => {
  const items = warnings || [];
  if (items.length === 0) return null;

  return (
    <div className="card">
      <div className="card-title">Issues ({items.length})</div>
      <div className="wp-list">
        {items.map((w, i) => {
          const s = SEV_STYLE[w.severity] || SEV_STYLE.info;
          return (
            <div
              key={i}
              className="wp-item"
              style={{ background: s.bg, borderColor: s.border }}
            >
              <div className="wp-icon" style={{ background: s.border }}>{s.icon}</div>
              <div className="wp-body">
                <div className="wp-code" style={{ color: s.color }}>
                  {w.code || w.severity}
                  {w.path && <span className="wp-path"> — {w.path}</span>}
                </div>
                <div className="wp-message">{w.message}</div>
                {w.fix_suggestion && (
                  <div className="wp-fix">Suggestion: {w.fix_suggestion}</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <style>{`
        .wp-list { display: flex; flex-direction: column; gap: 6px; }
        .wp-item { display: flex; gap: 10px; border: 1px solid; border-radius: 5px; padding: 8px 10px; font-size: 13px; }
        .wp-icon {
          flex: 0 0 20px; height: 20px; border-radius: 50%; color: white;
          display: flex; align-items: center; justify-content: center;
          font-size: 11px; font-weight: 700; margin-top: 1px;
        }
        .wp-body { flex: 1; min-width: 0; }
        .wp-code { font-weight: 600; font-size: 12px; text-transform: uppercase; letter-spacing: 0.04em; }
        .wp-path { font-family: monospace; text-transform: none; margin-left: 4px; font-size: 11px; }
        .wp-message { margin-top: 3px; color: #333; line-height: 1.4; }
        .wp-fix { margin-top: 3px; color: #555; font-style: italic; font-size: 12px; }
      `}</style>
    </div>
  );
};

export default WarningsPanel;
